var _g, _g2, _path, _path2, _path3, _g3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 56,
    viewBox: "0 0 50 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.3317 55.786L0.882812 49.366V13.1309L7.3317 6.71094H43.5379L49.9868 13.1309V49.366L43.5379 55.786H7.3317Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3317 49.1039L0.882812 42.6551V6.44885L7.3317 0H43.5379L49.9868 6.44885V42.6551L43.5379 49.1039H7.3317Z",
    fill: "black"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.3317 52.4305L0.882812 46.0105V9.7754L7.3317 3.35547H43.5379L49.9868 9.7754V46.0105L43.5379 52.4305H7.3317Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3317 49.1039L0.882812 42.6551V6.44885L7.3317 0H43.5379L49.9868 6.44885V42.6551L43.5379 49.1039H7.3317Z",
    fill: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.3259 51.966H7.4956C5.09535 49.5658 3.73619 48.2066 1.33594 45.8064V9.9761C3.73619 7.57585 5.09535 6.21666 7.4956 3.81641H43.3259C45.7261 6.21666 47.0853 7.57585 49.4856 9.9761V45.8064C47.0853 48.2066 45.7261 49.5658 43.3259 51.966Z",
    fill: "#404043"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3259 48.6106H7.4956C5.09535 46.2103 3.73619 44.8511 1.33594 42.4509V6.62063C3.73619 4.22038 5.09535 2.86119 7.4956 0.460938H43.3259C45.7261 2.86119 47.0853 4.22038 49.4856 6.62063V42.4509C47.0853 44.8511 45.7261 46.2103 43.3259 48.6106Z",
    fill: "#404043"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3259 48.6145H7.4956C5.09535 46.2142 3.73619 44.855 1.33594 42.4548V6.62454C3.73619 4.22429 5.09535 2.8651 7.4956 0.464844H43.3259C45.7261 2.8651 47.0853 4.22429 49.4856 6.62454V42.4548C47.0853 44.855 45.7261 46.2142 43.3259 48.6145Z",
    fill: "#212121"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.6029 2.22731L44.338 3.96243L47.7504 7.37485V41.7592L44.338 45.1716L42.6029 46.9067H8.21856L5.26887 43.957L3.09997 41.7881V7.40376L5.26887 5.23486L8.21856 2.28517H42.6029M43.3259 0.492188H7.4956C5.09535 2.89244 3.73619 4.25163 1.33594 6.65188V42.4822C3.73619 44.8824 5.09535 46.2416 7.4956 48.6418H43.3259C45.7261 46.2416 47.0853 44.8824 49.4856 42.4822V6.65188C47.0853 4.25163 45.7261 2.89244 43.3259 0.492188Z",
    fill: "black"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8343 1.7318L44.714 3.61151L48.271 7.16849V41.9577L44.714 45.5147L42.8343 47.3944H8.04506L5.3267 44.6761L2.60833 41.9577V7.16849L5.3267 4.45016L8.04506 1.7318H42.8343ZM43.3259 0.488281H7.4956C5.09535 2.88853 3.73619 4.24773 1.33594 6.64798V42.4782C3.73619 44.8785 5.09535 46.2377 7.4956 48.6379H43.3259C45.7261 46.2377 47.0853 44.8785 49.4856 42.4782V6.64798C47.0853 4.24773 45.7261 2.88853 43.3259 0.488281Z",
    fill: "#212121"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2856 16.793H31.3203V17.7583H32.2856V16.793Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3169 18.7266H30.3516V19.6919H31.3169V18.7266Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3169 19.6914H30.3516V20.6567H31.3169V19.6914Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3481 19.6914H29.3828V20.6567H30.3481V19.6914Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2075 18.7266H33.2422V19.6919H34.2075V18.7266Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2075 19.6914H33.2422V20.6567H34.2075V19.6914Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2856 17.7578H31.3203V18.7231H32.2856V17.7578Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0044 34.1797H39.0391V35.145H40.0044V34.1797Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0044 33.2109H39.0391V34.1763H40.0044V33.2109Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0044 32.2461H39.0391V33.2114H40.0044V32.2461Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0044 31.2773H39.0391V32.2427H40.0044V31.2773Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0044 30.3125H39.0391V31.2778H40.0044V30.3125Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0044 29.3438H39.0391V30.3091H40.0044V29.3438Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0044 28.3828H39.0391V29.3481H40.0044V28.3828Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0044 27.418H39.0391V28.3833H40.0044V27.418Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0044 26.4492H39.0391V27.4145H40.0044V26.4492Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0044 25.4883H39.0391V26.4536H40.0044V25.4883Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0044 24.5195H39.0391V25.4848H40.0044V24.5195Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0044 23.5547H39.0391V24.52H40.0044V23.5547Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0044 22.5859H39.0391V23.5513H40.0044V22.5859Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0044 21.6211H39.0391V22.5864H40.0044V21.6211Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0044 20.6523H39.0391V21.6177H40.0044V20.6523Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0044 19.6914H39.0391V20.6567H40.0044V19.6914Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0044 18.7266H39.0391V19.6919H40.0044V18.7266Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0044 17.7578H39.0391V18.7231H40.0044V17.7578Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0044 16.793H39.0391V17.7583H40.0044V16.793Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0044 15.8281H39.0391V16.7934H40.0044V15.8281Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0044 14.8633H39.0391V15.8286H40.0044V14.8633Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0434 35.1445H38.0781V36.1098H39.0434V35.1445Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0434 34.1797H38.0781V35.145H39.0434V34.1797Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0434 33.2109H38.0781V34.1763H39.0434V33.2109Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0434 32.2461H38.0781V33.2114H39.0434V32.2461Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0434 31.2773H38.0781V32.2427H39.0434V31.2773Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0434 30.3125H38.0781V31.2778H39.0434V30.3125Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0434 29.3438H38.0781V30.3091H39.0434V29.3438Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0434 28.3828H38.0781V29.3481H39.0434V28.3828Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0434 27.418H38.0781V28.3833H39.0434V27.418Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0434 26.4492H38.0781V27.4145H39.0434V26.4492Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0434 25.4883H38.0781V26.4536H39.0434V25.4883Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0434 24.5195H38.0781V25.4848H39.0434V24.5195Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0434 23.5547H38.0781V24.52H39.0434V23.5547Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0434 22.5859H38.0781V23.5513H39.0434V22.5859Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0434 21.6211H38.0781V22.5864H39.0434V21.6211Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0434 20.6523H38.0781V21.6177H39.0434V20.6523Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0434 19.6914H38.0781V20.6567H39.0434V19.6914Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0434 18.7266H38.0781V19.6919H39.0434V18.7266Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0434 17.7578H38.0781V18.7231H39.0434V17.7578Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0434 16.793H38.0781V17.7583H39.0434V16.793Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0434 15.8281H38.0781V16.7934H39.0434V15.8281Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0434 14.8633H38.0781V15.8286H39.0434V14.8633Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0434 13.8984H38.0781V14.8638H39.0434V13.8984Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0747 36.1094H37.1094V37.0747H38.0747V36.1094Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0747 35.1445H37.1094V36.1098H38.0747V35.1445Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0747 34.1797H37.1094V35.145H38.0747V34.1797Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0747 33.2109H37.1094V34.1763H38.0747V33.2109Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0747 32.2461H37.1094V33.2114H38.0747V32.2461Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0747 31.2773H37.1094V32.2427H38.0747V31.2773Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0747 30.3125H37.1094V31.2778H38.0747V30.3125Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0747 29.3438H37.1094V30.3091H38.0747V29.3438Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0747 28.3828H37.1094V29.3481H38.0747V28.3828Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0747 27.418H37.1094V28.3833H38.0747V27.418Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0747 26.4492H37.1094V27.4145H38.0747V26.4492Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0747 25.4883H37.1094V26.4536H38.0747V25.4883Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0747 24.5195H37.1094V25.4848H38.0747V24.5195Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0747 23.5547H37.1094V24.52H38.0747V23.5547Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0747 22.5859H37.1094V23.5513H38.0747V22.5859Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0747 21.6211H37.1094V22.5864H38.0747V21.6211Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0747 20.6523H37.1094V21.6177H38.0747V20.6523Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0747 19.6914H37.1094V20.6567H38.0747V19.6914Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0747 18.7266H37.1094V19.6919H38.0747V18.7266Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0747 17.7578H37.1094V18.7231H38.0747V17.7578Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0747 16.793H37.1094V17.7583H38.0747V16.793Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0747 15.8281H37.1094V16.7934H38.0747V15.8281Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0747 14.8633H37.1094V15.8286H38.0747V14.8633Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0747 13.8984H37.1094V14.8638H38.0747V13.8984Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0747 12.9336H37.1094V13.8989H38.0747V12.9336Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1059 37.0703H36.1406V38.0356H37.1059V37.0703Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1059 36.1094H36.1406V37.0747H37.1059V36.1094Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1059 35.1445H36.1406V36.1098H37.1059V35.1445Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1059 34.1797H36.1406V35.145H37.1059V34.1797Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1059 33.2109H36.1406V34.1763H37.1059V33.2109Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1059 32.2461H36.1406V33.2114H37.1059V32.2461Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1059 31.2773H36.1406V32.2427H37.1059V31.2773Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1059 30.3125H36.1406V31.2778H37.1059V30.3125Z",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1059 29.3438H36.1406V30.3091H37.1059V29.3438Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1059 28.3828H36.1406V29.3481H37.1059V28.3828Z",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1059 27.418H36.1406V28.3833H37.1059V27.418Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1059 26.4492H36.1406V27.4145H37.1059V26.4492Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1059 25.4883H36.1406V26.4536H37.1059V25.4883Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1059 24.5195H36.1406V25.4848H37.1059V24.5195Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1059 23.5547H36.1406V24.52H37.1059V23.5547Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1059 22.5859H36.1406V23.5513H37.1059V22.5859Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1059 21.6211H36.1406V22.5864H37.1059V21.6211Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1059 20.6523H36.1406V21.6177H37.1059V20.6523Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1059 19.6914H36.1406V20.6567H37.1059V19.6914Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1059 18.7266H36.1406V19.6919H37.1059V18.7266Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1059 17.7578H36.1406V18.7231H37.1059V17.7578Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1059 16.793H36.1406V17.7583H37.1059V16.793Z",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1059 15.8281H36.1406V16.7934H37.1059V15.8281Z",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1059 14.8633H36.1406V15.8286H37.1059V14.8633Z",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1059 13.8984H36.1406V14.8638H37.1059V13.8984Z",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1059 12.9336H36.1406V13.8989H37.1059V12.9336Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1059 11.9648H36.1406V12.9302H37.1059V11.9648Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1372 38.0391H35.1719V39.0044H36.1372V38.0391Z",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1372 37.0703H35.1719V38.0356H36.1372V37.0703Z",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1372 36.1094H35.1719V37.0747H36.1372V36.1094Z",
    fill: "white"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1372 35.1445H35.1719V36.1098H36.1372V35.1445Z",
    fill: "white"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1372 34.1797H35.1719V35.145H36.1372V34.1797Z",
    fill: "white"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1372 33.2109H35.1719V34.1763H36.1372V33.2109Z",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1372 32.2461H35.1719V33.2114H36.1372V32.2461Z",
    fill: "white"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1372 31.2773H35.1719V32.2427H36.1372V31.2773Z",
    fill: "white"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1372 30.3125H35.1719V31.2778H36.1372V30.3125Z",
    fill: "white"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1372 29.3438H35.1719V30.3091H36.1372V29.3438Z",
    fill: "white"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1372 28.3828H35.1719V29.3481H36.1372V28.3828Z",
    fill: "white"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1372 27.418H35.1719V28.3833H36.1372V27.418Z",
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1372 26.4492H35.1719V27.4145H36.1372V26.4492Z",
    fill: "white"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1372 25.4883H35.1719V26.4536H36.1372V25.4883Z",
    fill: "white"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1372 24.5195H35.1719V25.4848H36.1372V24.5195Z",
    fill: "white"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1372 23.5547H35.1719V24.52H36.1372V23.5547Z",
    fill: "white"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1372 22.5859H35.1719V23.5513H36.1372V22.5859Z",
    fill: "white"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1372 21.6211H35.1719V22.5864H36.1372V21.6211Z",
    fill: "white"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1372 20.6523H35.1719V21.6177H36.1372V20.6523Z",
    fill: "white"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1372 19.6914H35.1719V20.6567H36.1372V19.6914Z",
    fill: "white"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1372 18.7266H35.1719V19.6919H36.1372V18.7266Z",
    fill: "white"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1372 17.7578H35.1719V18.7231H36.1372V17.7578Z",
    fill: "white"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1372 16.793H35.1719V17.7583H36.1372V16.793Z",
    fill: "white"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1372 15.8281H35.1719V16.7934H36.1372V15.8281Z",
    fill: "white"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1372 14.8633H35.1719V15.8286H36.1372V14.8633Z",
    fill: "white"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1372 13.8984H35.1719V14.8638H36.1372V13.8984Z",
    fill: "white"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1372 12.9336H35.1719V13.8989H36.1372V12.9336Z",
    fill: "white"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1372 11.9648H35.1719V12.9302H36.1372V11.9648Z",
    fill: "white"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1372 11H35.1719V11.9653H36.1372V11Z",
    fill: "white"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1763 38.0391H34.2109V39.0044H35.1763V38.0391Z",
    fill: "white"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1763 37.0703H34.2109V38.0356H35.1763V37.0703Z",
    fill: "white"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1763 36.1094H34.2109V37.0747H35.1763V36.1094Z",
    fill: "white"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1763 35.1445H34.2109V36.1098H35.1763V35.1445Z",
    fill: "white"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1763 34.1797H34.2109V35.145H35.1763V34.1797Z",
    fill: "white"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1763 33.2109H34.2109V34.1763H35.1763V33.2109Z",
    fill: "white"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1763 16.793H34.2109V17.7583H35.1763V16.793Z",
    fill: "white"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1763 15.8281H34.2109V16.7934H35.1763V15.8281Z",
    fill: "white"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1763 14.8633H34.2109V15.8286H35.1763V14.8633Z",
    fill: "white"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1763 13.8984H34.2109V14.8638H35.1763V13.8984Z",
    fill: "white"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1763 12.9336H34.2109V13.8989H35.1763V12.9336Z",
    fill: "white"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1763 11.9648H34.2109V12.9302H35.1763V11.9648Z",
    fill: "white"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1763 11H34.2109V11.9653H35.1763V11Z",
    fill: "white"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2075 38.0391H33.2422V39.0044H34.2075V38.0391Z",
    fill: "white"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2075 37.0703H33.2422V38.0356H34.2075V37.0703Z",
    fill: "white"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2075 36.1094H33.2422V37.0747H34.2075V36.1094Z",
    fill: "white"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2075 35.1445H33.2422V36.1098H34.2075V35.1445Z",
    fill: "white"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2075 34.1797H33.2422V35.145H34.2075V34.1797Z",
    fill: "white"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2075 30.3125H33.2422V31.2778H34.2075V30.3125Z",
    fill: "white"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2075 29.3438H33.2422V30.3091H34.2075V29.3438Z",
    fill: "white"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2075 28.3828H33.2422V29.3481H34.2075V28.3828Z",
    fill: "white"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2075 27.418H33.2422V28.3833H34.2075V27.418Z",
    fill: "white"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2075 26.4492H33.2422V27.4145H34.2075V26.4492Z",
    fill: "white"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2075 25.4883H33.2422V26.4536H34.2075V25.4883Z",
    fill: "white"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2075 24.5195H33.2422V25.4848H34.2075V24.5195Z",
    fill: "white"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2075 23.5547H33.2422V24.52H34.2075V23.5547Z",
    fill: "white"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2075 22.5859H33.2422V23.5513H34.2075V22.5859Z",
    fill: "white"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2075 21.6211H33.2422V22.5864H34.2075V21.6211Z",
    fill: "white"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2075 20.6523H33.2422V21.6177H34.2075V20.6523Z",
    fill: "white"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2075 15.8281H33.2422V16.7934H34.2075V15.8281Z",
    fill: "white"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2075 14.8633H33.2422V15.8286H34.2075V14.8633Z",
    fill: "white"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2075 13.8984H33.2422V14.8638H34.2075V13.8984Z",
    fill: "white"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2075 12.9336H33.2422V13.8989H34.2075V12.9336Z",
    fill: "white"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2075 11.9648H33.2422V12.9302H34.2075V11.9648Z",
    fill: "white"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2075 11H33.2422V11.9653H34.2075V11Z",
    fill: "white"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2466 38.0391H32.2812V39.0044H33.2466V38.0391Z",
    fill: "white"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2466 37.0703H32.2812V38.0356H33.2466V37.0703Z",
    fill: "white"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2466 36.1094H32.2812V37.0747H33.2466V36.1094Z",
    fill: "white"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2466 35.1445H32.2812V36.1098H33.2466V35.1445Z",
    fill: "white"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2466 31.2773H32.2812V32.2427H33.2466V31.2773Z",
    fill: "white"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2466 30.3125H32.2812V31.2778H33.2466V30.3125Z",
    fill: "white"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2466 29.3438H32.2812V30.3091H33.2466V29.3438Z",
    fill: "white"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2466 28.3828H32.2812V29.3481H33.2466V28.3828Z",
    fill: "white"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2466 27.418H32.2812V28.3833H33.2466V27.418Z",
    fill: "white"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2466 26.4492H32.2812V27.4145H33.2466V26.4492Z",
    fill: "white"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2466 25.4883H32.2812V26.4536H33.2466V25.4883Z",
    fill: "white"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2466 24.5195H32.2812V25.4848H33.2466V24.5195Z",
    fill: "white"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2466 23.5547H32.2812V24.52H33.2466V23.5547Z",
    fill: "white"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2466 22.5859H32.2812V23.5513H33.2466V22.5859Z",
    fill: "white"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2466 21.6211H32.2812V22.5864H33.2466V21.6211Z",
    fill: "white"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2466 20.6523H32.2812V21.6177H33.2466V20.6523Z",
    fill: "white"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2466 17.7578H32.2812V18.7231H33.2466V17.7578Z",
    fill: "white"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2466 14.8633H32.2812V15.8286H33.2466V14.8633Z",
    fill: "white"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2466 13.8984H32.2812V14.8638H33.2466V13.8984Z",
    fill: "white"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2466 12.9336H32.2812V13.8989H33.2466V12.9336Z",
    fill: "white"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2466 11.9648H32.2812V12.9302H33.2466V11.9648Z",
    fill: "white"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2466 11H32.2812V11.9653H33.2466V11Z",
    fill: "white"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2856 38.0391H31.3203V39.0044H32.2856V38.0391Z",
    fill: "white"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2856 37.0703H31.3203V38.0356H32.2856V37.0703Z",
    fill: "white"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2856 36.1094H31.3203V37.0747H32.2856V36.1094Z",
    fill: "white"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2856 35.1445H31.3203V36.1098H32.2856V35.1445Z",
    fill: "white"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2856 32.2461H31.3203V33.2114H32.2856V32.2461Z",
    fill: "white"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2856 31.2773H31.3203V32.2427H32.2856V31.2773Z",
    fill: "white"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2856 30.3125H31.3203V31.2778H32.2856V30.3125Z",
    fill: "white"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2856 29.3438H31.3203V30.3091H32.2856V29.3438Z",
    fill: "white"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2856 28.3828H31.3203V29.3481H32.2856V28.3828Z",
    fill: "white"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2856 27.418H31.3203V28.3833H32.2856V27.418Z",
    fill: "white"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2856 26.4492H31.3203V27.4145H32.2856V26.4492Z",
    fill: "white"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2856 25.4883H31.3203V26.4536H32.2856V25.4883Z",
    fill: "white"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2856 24.5195H31.3203V25.4848H32.2856V24.5195Z",
    fill: "white"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2856 23.5547H31.3203V24.52H32.2856V23.5547Z",
    fill: "white"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2856 22.5859H31.3203V23.5513H32.2856V22.5859Z",
    fill: "white"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2856 21.6211H31.3203V22.5864H32.2856V21.6211Z",
    fill: "white"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2856 20.6523H31.3203V21.6177H32.2856V20.6523Z",
    fill: "white"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2856 14.8633H31.3203V15.8286H32.2856V14.8633Z",
    fill: "white"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2856 13.8984H31.3203V14.8638H32.2856V13.8984Z",
    fill: "white"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2856 12.9336H31.3203V13.8989H32.2856V12.9336Z",
    fill: "white"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2856 11.9648H31.3203V12.9302H32.2856V11.9648Z",
    fill: "white"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2856 11H31.3203V11.9653H32.2856V11Z",
    fill: "white"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3169 38.0391H30.3516V39.0044H31.3169V38.0391Z",
    fill: "white"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3169 37.0703H30.3516V38.0356H31.3169V37.0703Z",
    fill: "white"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3169 36.1094H30.3516V37.0747H31.3169V36.1094Z",
    fill: "white"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3169 35.1445H30.3516V36.1098H31.3169V35.1445Z",
    fill: "white"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3169 33.2109H30.3516V34.1763H31.3169V33.2109Z",
    fill: "white"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3169 32.2461H30.3516V33.2114H31.3169V32.2461Z",
    fill: "white"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3169 31.2773H30.3516V32.2427H31.3169V31.2773Z",
    fill: "white"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3169 30.3125H30.3516V31.2778H31.3169V30.3125Z",
    fill: "white"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3169 29.3438H30.3516V30.3091H31.3169V29.3438Z",
    fill: "white"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3169 28.3828H30.3516V29.3481H31.3169V28.3828Z",
    fill: "white"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3169 27.418H30.3516V28.3833H31.3169V27.418Z",
    fill: "white"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3169 22.5859H30.3516V23.5513H31.3169V22.5859Z",
    fill: "white"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3169 21.6211H30.3516V22.5864H31.3169V21.6211Z",
    fill: "white"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3169 20.6523H30.3516V21.6177H31.3169V20.6523Z",
    fill: "white"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3169 17.7578H30.3516V18.7231H31.3169V17.7578Z",
    fill: "white"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3169 16.793H30.3516V17.7583H31.3169V16.793Z",
    fill: "white"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3169 14.8633H30.3516V15.8286H31.3169V14.8633Z",
    fill: "white"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3169 13.8984H30.3516V14.8638H31.3169V13.8984Z",
    fill: "white"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3169 12.9336H30.3516V13.8989H31.3169V12.9336Z",
    fill: "white"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3169 11.9648H30.3516V12.9302H31.3169V11.9648Z",
    fill: "white"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3169 11H30.3516V11.9653H31.3169V11Z",
    fill: "white"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3481 38.0391H29.3828V39.0044H30.3481V38.0391Z",
    fill: "white"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3481 37.0703H29.3828V38.0356H30.3481V37.0703Z",
    fill: "white"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3481 36.1094H29.3828V37.0747H30.3481V36.1094Z",
    fill: "white"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3481 35.1445H29.3828V36.1098H30.3481V35.1445Z",
    fill: "white"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3481 33.2109H29.3828V34.1763H30.3481V33.2109Z",
    fill: "white"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3481 32.2461H29.3828V33.2114H30.3481V32.2461Z",
    fill: "white"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3481 31.2773H29.3828V32.2427H30.3481V31.2773Z",
    fill: "white"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3481 30.3125H29.3828V31.2778H30.3481V30.3125Z",
    fill: "white"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3481 29.3438H29.3828V30.3091H30.3481V29.3438Z",
    fill: "white"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3481 28.3828H29.3828V29.3481H30.3481V28.3828Z",
    fill: "white"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3481 21.6211H29.3828V22.5864H30.3481V21.6211Z",
    fill: "white"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3481 20.6523H29.3828V21.6177H30.3481V20.6523Z",
    fill: "white"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3481 18.7266H29.3828V19.6919H30.3481V18.7266Z",
    fill: "white"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3481 17.7578H29.3828V18.7231H30.3481V17.7578Z",
    fill: "white"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3481 16.793H29.3828V17.7583H30.3481V16.793Z",
    fill: "white"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3481 14.8633H29.3828V15.8286H30.3481V14.8633Z",
    fill: "white"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3481 13.8984H29.3828V14.8638H30.3481V13.8984Z",
    fill: "white"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3481 12.9336H29.3828V13.8989H30.3481V12.9336Z",
    fill: "white"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3481 11.9648H29.3828V12.9302H30.3481V11.9648Z",
    fill: "white"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3481 11H29.3828V11.9653H30.3481V11Z",
    fill: "white"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3794 38.0391H28.4141V39.0044H29.3794V38.0391Z",
    fill: "white"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3794 37.0703H28.4141V38.0356H29.3794V37.0703Z",
    fill: "white"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3794 36.1094H28.4141V37.0747H29.3794V36.1094Z",
    fill: "white"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3794 35.1445H28.4141V36.1098H29.3794V35.1445Z",
    fill: "white"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3794 33.2109H28.4141V34.1763H29.3794V33.2109Z",
    fill: "white"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3794 32.2461H28.4141V33.2114H29.3794V32.2461Z",
    fill: "white"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3794 31.2773H28.4141V32.2427H29.3794V31.2773Z",
    fill: "white"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3794 30.3125H28.4141V31.2778H29.3794V30.3125Z",
    fill: "white"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3794 29.3438H28.4141V30.3091H29.3794V29.3438Z",
    fill: "white"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3794 20.6523H28.4141V21.6177H29.3794V20.6523Z",
    fill: "white"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3794 19.6914H28.4141V20.6567H29.3794V19.6914Z",
    fill: "white"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3794 18.7266H28.4141V19.6919H29.3794V18.7266Z",
    fill: "white"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3794 17.7578H28.4141V18.7231H29.3794V17.7578Z",
    fill: "white"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3794 16.793H28.4141V17.7583H29.3794V16.793Z",
    fill: "white"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3794 14.8633H28.4141V15.8286H29.3794V14.8633Z",
    fill: "white"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3794 13.8984H28.4141V14.8638H29.3794V13.8984Z",
    fill: "white"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3794 12.9336H28.4141V13.8989H29.3794V12.9336Z",
    fill: "white"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3794 11.9648H28.4141V12.9302H29.3794V11.9648Z",
    fill: "white"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3794 11H28.4141V11.9653H29.3794V11Z",
    fill: "white"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4184 38.0391H27.4531V39.0044H28.4184V38.0391Z",
    fill: "white"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4184 37.0703H27.4531V38.0356H28.4184V37.0703Z",
    fill: "white"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4184 36.1094H27.4531V37.0747H28.4184V36.1094Z",
    fill: "white"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4184 35.1445H27.4531V36.1098H28.4184V35.1445Z",
    fill: "white"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4184 33.2109H27.4531V34.1763H28.4184V33.2109Z",
    fill: "white"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4184 32.2461H27.4531V33.2114H28.4184V32.2461Z",
    fill: "white"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4184 31.2773H27.4531V32.2427H28.4184V31.2773Z",
    fill: "white"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4184 30.3125H27.4531V31.2778H28.4184V30.3125Z",
    fill: "white"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4184 19.6914H27.4531V20.6567H28.4184V19.6914Z",
    fill: "white"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4184 18.7266H27.4531V19.6919H28.4184V18.7266Z",
    fill: "white"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4184 17.7578H27.4531V18.7231H28.4184V17.7578Z",
    fill: "white"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4184 16.793H27.4531V17.7583H28.4184V16.793Z",
    fill: "white"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4184 14.8633H27.4531V15.8286H28.4184V14.8633Z",
    fill: "white"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4184 13.8984H27.4531V14.8638H28.4184V13.8984Z",
    fill: "white"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4184 12.9336H27.4531V13.8989H28.4184V12.9336Z",
    fill: "white"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4184 11.9648H27.4531V12.9302H28.4184V11.9648Z",
    fill: "white"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4184 11H27.4531V11.9653H28.4184V11Z",
    fill: "white"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4497 38.0391H26.4844V39.0044H27.4497V38.0391Z",
    fill: "white"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4497 37.0703H26.4844V38.0356H27.4497V37.0703Z",
    fill: "white"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4497 36.1094H26.4844V37.0747H27.4497V36.1094Z",
    fill: "white"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4497 35.1445H26.4844V36.1098H27.4497V35.1445Z",
    fill: "white"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4497 33.2109H26.4844V34.1763H27.4497V33.2109Z",
    fill: "white"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4497 32.2461H26.4844V33.2114H27.4497V32.2461Z",
    fill: "white"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4497 31.2773H26.4844V32.2427H27.4497V31.2773Z",
    fill: "white"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4497 30.3125H26.4844V31.2778H27.4497V30.3125Z",
    fill: "white"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4497 19.6914H26.4844V20.6567H27.4497V19.6914Z",
    fill: "white"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4497 18.7266H26.4844V19.6919H27.4497V18.7266Z",
    fill: "white"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4497 17.7578H26.4844V18.7231H27.4497V17.7578Z",
    fill: "white"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4497 16.793H26.4844V17.7583H27.4497V16.793Z",
    fill: "white"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4497 14.8633H26.4844V15.8286H27.4497V14.8633Z",
    fill: "white"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4497 13.8984H26.4844V14.8638H27.4497V13.8984Z",
    fill: "white"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4497 12.9336H26.4844V13.8989H27.4497V12.9336Z",
    fill: "white"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4497 11.9648H26.4844V12.9302H27.4497V11.9648Z",
    fill: "white"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4497 11H26.4844V11.9653H27.4497V11Z",
    fill: "white"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4809 38.0391H25.5156V39.0044H26.4809V38.0391Z",
    fill: "white"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4809 37.0703H25.5156V38.0356H26.4809V37.0703Z",
    fill: "white"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4809 36.1094H25.5156V37.0747H26.4809V36.1094Z",
    fill: "white"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4809 35.1445H25.5156V36.1098H26.4809V35.1445Z",
    fill: "white"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4809 33.2109H25.5156V34.1763H26.4809V33.2109Z",
    fill: "white"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4809 32.2461H25.5156V33.2114H26.4809V32.2461Z",
    fill: "white"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4809 31.2773H25.5156V32.2427H26.4809V31.2773Z",
    fill: "white"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4809 30.3125H25.5156V31.2778H26.4809V30.3125Z",
    fill: "white"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4809 19.6914H25.5156V20.6567H26.4809V19.6914Z",
    fill: "white"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4809 18.7266H25.5156V19.6919H26.4809V18.7266Z",
    fill: "white"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4809 17.7578H25.5156V18.7231H26.4809V17.7578Z",
    fill: "white"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4809 16.793H25.5156V17.7583H26.4809V16.793Z",
    fill: "white"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4809 14.8633H25.5156V15.8286H26.4809V14.8633Z",
    fill: "white"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4809 13.8984H25.5156V14.8638H26.4809V13.8984Z",
    fill: "white"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4809 12.9336H25.5156V13.8989H26.4809V12.9336Z",
    fill: "white"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4809 11.9648H25.5156V12.9302H26.4809V11.9648Z",
    fill: "white"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4809 11H25.5156V11.9653H26.4809V11Z",
    fill: "white"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5122 38.0391H24.5469V39.0044H25.5122V38.0391Z",
    fill: "white"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5122 37.0703H24.5469V38.0356H25.5122V37.0703Z",
    fill: "white"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5122 36.1094H24.5469V37.0747H25.5122V36.1094Z",
    fill: "white"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5122 35.1445H24.5469V36.1098H25.5122V35.1445Z",
    fill: "white"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5122 33.2109H24.5469V34.1763H25.5122V33.2109Z",
    fill: "white"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5122 32.2461H24.5469V33.2114H25.5122V32.2461Z",
    fill: "white"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5122 31.2773H24.5469V32.2427H25.5122V31.2773Z",
    fill: "white"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5122 30.3125H24.5469V31.2778H25.5122V30.3125Z",
    fill: "white"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5122 19.6914H24.5469V20.6567H25.5122V19.6914Z",
    fill: "white"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5122 18.7266H24.5469V19.6919H25.5122V18.7266Z",
    fill: "white"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5122 17.7578H24.5469V18.7231H25.5122V17.7578Z",
    fill: "white"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5122 16.793H24.5469V17.7583H25.5122V16.793Z",
    fill: "white"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5122 14.8633H24.5469V15.8286H25.5122V14.8633Z",
    fill: "white"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5122 13.8984H24.5469V14.8638H25.5122V13.8984Z",
    fill: "white"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5122 12.9336H24.5469V13.8989H25.5122V12.9336Z",
    fill: "white"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5122 11.9648H24.5469V12.9302H25.5122V11.9648Z",
    fill: "white"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5122 11H24.5469V11.9653H25.5122V11Z",
    fill: "white"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5513 38.0391H23.5859V39.0044H24.5513V38.0391Z",
    fill: "white"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5513 37.0703H23.5859V38.0356H24.5513V37.0703Z",
    fill: "white"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5513 36.1094H23.5859V37.0747H24.5513V36.1094Z",
    fill: "white"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5513 35.1445H23.5859V36.1098H24.5513V35.1445Z",
    fill: "white"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5513 33.2109H23.5859V34.1763H24.5513V33.2109Z",
    fill: "white"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5513 32.2461H23.5859V33.2114H24.5513V32.2461Z",
    fill: "white"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5513 31.2773H23.5859V32.2427H24.5513V31.2773Z",
    fill: "white"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5513 30.3125H23.5859V31.2778H24.5513V30.3125Z",
    fill: "white"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5513 19.6914H23.5859V20.6567H24.5513V19.6914Z",
    fill: "white"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5513 18.7266H23.5859V19.6919H24.5513V18.7266Z",
    fill: "white"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5513 17.7578H23.5859V18.7231H24.5513V17.7578Z",
    fill: "white"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5513 16.793H23.5859V17.7583H24.5513V16.793Z",
    fill: "white"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5513 14.8633H23.5859V15.8286H24.5513V14.8633Z",
    fill: "white"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5513 13.8984H23.5859V14.8638H24.5513V13.8984Z",
    fill: "white"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5513 12.9336H23.5859V13.8989H24.5513V12.9336Z",
    fill: "white"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5513 11.9648H23.5859V12.9302H24.5513V11.9648Z",
    fill: "white"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5513 11H23.5859V11.9653H24.5513V11Z",
    fill: "white"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5825 38.0391H22.6172V39.0044H23.5825V38.0391Z",
    fill: "white"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5825 37.0703H22.6172V38.0356H23.5825V37.0703Z",
    fill: "white"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5825 36.1094H22.6172V37.0747H23.5825V36.1094Z",
    fill: "white"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5825 35.1445H22.6172V36.1098H23.5825V35.1445Z",
    fill: "white"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5825 33.2109H22.6172V34.1763H23.5825V33.2109Z",
    fill: "white"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5825 32.2461H22.6172V33.2114H23.5825V32.2461Z",
    fill: "white"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5825 31.2773H22.6172V32.2427H23.5825V31.2773Z",
    fill: "white"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5825 30.3125H22.6172V31.2778H23.5825V30.3125Z",
    fill: "white"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5825 29.3438H22.6172V30.3091H23.5825V29.3438Z",
    fill: "white"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5825 20.6523H22.6172V21.6177H23.5825V20.6523Z",
    fill: "white"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5825 19.6914H22.6172V20.6567H23.5825V19.6914Z",
    fill: "white"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5825 18.7266H22.6172V19.6919H23.5825V18.7266Z",
    fill: "white"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5825 17.7578H22.6172V18.7231H23.5825V17.7578Z",
    fill: "white"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5825 16.793H22.6172V17.7583H23.5825V16.793Z",
    fill: "white"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5825 14.8633H22.6172V15.8286H23.5825V14.8633Z",
    fill: "white"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5825 13.8984H22.6172V14.8638H23.5825V13.8984Z",
    fill: "white"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5825 12.9336H22.6172V13.8989H23.5825V12.9336Z",
    fill: "white"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5825 11.9648H22.6172V12.9302H23.5825V11.9648Z",
    fill: "white"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5825 11H22.6172V11.9653H23.5825V11Z",
    fill: "white"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6216 38.0391H21.6562V39.0044H22.6216V38.0391Z",
    fill: "white"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6216 37.0703H21.6562V38.0356H22.6216V37.0703Z",
    fill: "white"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6216 36.1094H21.6562V37.0747H22.6216V36.1094Z",
    fill: "white"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6216 35.1445H21.6562V36.1098H22.6216V35.1445Z",
    fill: "white"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6216 33.2109H21.6562V34.1763H22.6216V33.2109Z",
    fill: "white"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6216 32.2461H21.6562V33.2114H22.6216V32.2461Z",
    fill: "white"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6216 31.2773H21.6562V32.2427H22.6216V31.2773Z",
    fill: "white"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6216 30.3125H21.6562V31.2778H22.6216V30.3125Z",
    fill: "white"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6216 29.3438H21.6562V30.3091H22.6216V29.3438Z",
    fill: "white"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6216 28.3828H21.6562V29.3481H22.6216V28.3828Z",
    fill: "white"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6216 21.6211H21.6562V22.5864H22.6216V21.6211Z",
    fill: "white"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6216 20.6523H21.6562V21.6177H22.6216V20.6523Z",
    fill: "white"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6216 19.6914H21.6562V20.6567H22.6216V19.6914Z",
    fill: "white"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6216 18.7266H21.6562V19.6919H22.6216V18.7266Z",
    fill: "white"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6216 17.7578H21.6562V18.7231H22.6216V17.7578Z",
    fill: "white"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6216 16.793H21.6562V17.7583H22.6216V16.793Z",
    fill: "white"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6216 14.8633H21.6562V15.8286H22.6216V14.8633Z",
    fill: "white"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6216 13.8984H21.6562V14.8638H22.6216V13.8984Z",
    fill: "white"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6216 12.9336H21.6562V13.8989H22.6216V12.9336Z",
    fill: "white"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6216 11.9648H21.6562V12.9302H22.6216V11.9648Z",
    fill: "white"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6216 11H21.6562V11.9653H22.6216V11Z",
    fill: "white"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6528 38.0391H20.6875V39.0044H21.6528V38.0391Z",
    fill: "white"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6528 37.0703H20.6875V38.0356H21.6528V37.0703Z",
    fill: "white"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6528 36.1094H20.6875V37.0747H21.6528V36.1094Z",
    fill: "white"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6528 35.1445H20.6875V36.1098H21.6528V35.1445Z",
    fill: "white"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6528 33.2109H20.6875V34.1763H21.6528V33.2109Z",
    fill: "white"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6528 32.2461H20.6875V33.2114H21.6528V32.2461Z",
    fill: "white"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6528 31.2773H20.6875V32.2427H21.6528V31.2773Z",
    fill: "white"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6528 30.3125H20.6875V31.2778H21.6528V30.3125Z",
    fill: "white"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6528 29.3438H20.6875V30.3091H21.6528V29.3438Z",
    fill: "white"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6528 28.3828H20.6875V29.3481H21.6528V28.3828Z",
    fill: "white"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6528 27.418H20.6875V28.3833H21.6528V27.418Z",
    fill: "white"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6528 22.5859H20.6875V23.5513H21.6528V22.5859Z",
    fill: "white"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6528 21.6211H20.6875V22.5864H21.6528V21.6211Z",
    fill: "white"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6528 20.6523H20.6875V21.6177H21.6528V20.6523Z",
    fill: "white"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6528 19.6914H20.6875V20.6567H21.6528V19.6914Z",
    fill: "white"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6528 18.7266H20.6875V19.6919H21.6528V18.7266Z",
    fill: "white"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6528 17.7578H20.6875V18.7231H21.6528V17.7578Z",
    fill: "white"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6528 16.793H20.6875V17.7583H21.6528V16.793Z",
    fill: "white"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6528 14.8633H20.6875V15.8286H21.6528V14.8633Z",
    fill: "white"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6528 13.8984H20.6875V14.8638H21.6528V13.8984Z",
    fill: "white"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6528 12.9336H20.6875V13.8989H21.6528V12.9336Z",
    fill: "white"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6528 11.9648H20.6875V12.9302H21.6528V11.9648Z",
    fill: "white"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6528 11H20.6875V11.9653H21.6528V11Z",
    fill: "white"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6919 38.0391H19.7266V39.0044H20.6919V38.0391Z",
    fill: "white"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6919 37.0703H19.7266V38.0356H20.6919V37.0703Z",
    fill: "white"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6919 36.1094H19.7266V37.0747H20.6919V36.1094Z",
    fill: "white"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6919 35.1445H19.7266V36.1098H20.6919V35.1445Z",
    fill: "white"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6919 32.2461H19.7266V33.2114H20.6919V32.2461Z",
    fill: "white"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6919 31.2773H19.7266V32.2427H20.6919V31.2773Z",
    fill: "white"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6919 30.3125H19.7266V31.2778H20.6919V30.3125Z",
    fill: "white"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6919 29.3438H19.7266V30.3091H20.6919V29.3438Z",
    fill: "white"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6919 28.3828H19.7266V29.3481H20.6919V28.3828Z",
    fill: "white"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6919 27.418H19.7266V28.3833H20.6919V27.418Z",
    fill: "white"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6919 26.4492H19.7266V27.4145H20.6919V26.4492Z",
    fill: "white"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6919 25.4883H19.7266V26.4536H20.6919V25.4883Z",
    fill: "white"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6919 24.5195H19.7266V25.4848H20.6919V24.5195Z",
    fill: "white"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6919 23.5547H19.7266V24.52H20.6919V23.5547Z",
    fill: "white"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6919 22.5859H19.7266V23.5513H20.6919V22.5859Z",
    fill: "white"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6919 21.6211H19.7266V22.5864H20.6919V21.6211Z",
    fill: "white"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6919 20.6523H19.7266V21.6177H20.6919V20.6523Z",
    fill: "white"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6919 19.6914H19.7266V20.6567H20.6919V19.6914Z",
    fill: "white"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6919 18.7266H19.7266V19.6919H20.6919V18.7266Z",
    fill: "white"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6919 17.7578H19.7266V18.7231H20.6919V17.7578Z",
    fill: "white"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6919 14.8633H19.7266V15.8286H20.6919V14.8633Z",
    fill: "white"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6919 13.8984H19.7266V14.8638H20.6919V13.8984Z",
    fill: "white"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6919 12.9336H19.7266V13.8989H20.6919V12.9336Z",
    fill: "white"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6919 11.9648H19.7266V12.9302H20.6919V11.9648Z",
    fill: "white"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6919 11H19.7266V11.9653H20.6919V11Z",
    fill: "white"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7231 38.0391H18.7578V39.0044H19.7231V38.0391Z",
    fill: "white"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7231 37.0703H18.7578V38.0356H19.7231V37.0703Z",
    fill: "white"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7231 36.1094H18.7578V37.0747H19.7231V36.1094Z",
    fill: "white"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7231 35.1445H18.7578V36.1098H19.7231V35.1445Z",
    fill: "white"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7231 31.2773H18.7578V32.2427H19.7231V31.2773Z",
    fill: "white"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7231 30.3125H18.7578V31.2778H19.7231V30.3125Z",
    fill: "white"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7231 29.3438H18.7578V30.3091H19.7231V29.3438Z",
    fill: "white"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7231 28.3828H18.7578V29.3481H19.7231V28.3828Z",
    fill: "white"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7231 27.418H18.7578V28.3833H19.7231V27.418Z",
    fill: "white"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7231 26.4492H18.7578V27.4145H19.7231V26.4492Z",
    fill: "white"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7231 25.4883H18.7578V26.4536H19.7231V25.4883Z",
    fill: "white"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7231 24.5195H18.7578V25.4848H19.7231V24.5195Z",
    fill: "white"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7231 23.5547H18.7578V24.52H19.7231V23.5547Z",
    fill: "white"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7231 22.5859H18.7578V23.5513H19.7231V22.5859Z",
    fill: "white"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7231 21.6211H18.7578V22.5864H19.7231V21.6211Z",
    fill: "white"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7231 20.6523H18.7578V21.6177H19.7231V20.6523Z",
    fill: "white"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7231 19.6914H18.7578V20.6567H19.7231V19.6914Z",
    fill: "white"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7231 18.7266H18.7578V19.6919H19.7231V18.7266Z",
    fill: "white"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7231 14.8633H18.7578V15.8286H19.7231V14.8633Z",
    fill: "white"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7231 13.8984H18.7578V14.8638H19.7231V13.8984Z",
    fill: "white"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7231 12.9336H18.7578V13.8989H19.7231V12.9336Z",
    fill: "white"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7231 11.9648H18.7578V12.9302H19.7231V11.9648Z",
    fill: "white"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7231 11H18.7578V11.9653H19.7231V11Z",
    fill: "white"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7622 38.0391H17.7969V39.0044H18.7622V38.0391Z",
    fill: "white"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7622 37.0703H17.7969V38.0356H18.7622V37.0703Z",
    fill: "white"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7622 36.1094H17.7969V37.0747H18.7622V36.1094Z",
    fill: "white"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7622 35.1445H17.7969V36.1098H18.7622V35.1445Z",
    fill: "white"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7622 34.1797H17.7969V35.145H18.7622V34.1797Z",
    fill: "white"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7622 30.3125H17.7969V31.2778H18.7622V30.3125Z",
    fill: "white"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7622 29.3438H17.7969V30.3091H18.7622V29.3438Z",
    fill: "white"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7622 28.3828H17.7969V29.3481H18.7622V28.3828Z",
    fill: "white"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7622 27.418H17.7969V28.3833H18.7622V27.418Z",
    fill: "white"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7622 26.4492H17.7969V27.4145H18.7622V26.4492Z",
    fill: "white"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7622 25.4883H17.7969V26.4536H18.7622V25.4883Z",
    fill: "white"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7622 24.5195H17.7969V25.4848H18.7622V24.5195Z",
    fill: "white"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7622 23.5547H17.7969V24.52H18.7622V23.5547Z",
    fill: "white"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7622 22.5859H17.7969V23.5513H18.7622V22.5859Z",
    fill: "white"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7622 21.6211H17.7969V22.5864H18.7622V21.6211Z",
    fill: "white"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7622 20.6523H17.7969V21.6177H18.7622V20.6523Z",
    fill: "white"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7622 19.6914H17.7969V20.6567H18.7622V19.6914Z",
    fill: "white"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7622 15.8281H17.7969V16.7934H18.7622V15.8281Z",
    fill: "white"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7622 14.8633H17.7969V15.8286H18.7622V14.8633Z",
    fill: "white"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7622 13.8984H17.7969V14.8638H18.7622V13.8984Z",
    fill: "white"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7622 12.9336H17.7969V13.8989H18.7622V12.9336Z",
    fill: "white"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7622 11.9648H17.7969V12.9302H18.7622V11.9648Z",
    fill: "white"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7622 11H17.7969V11.9653H18.7622V11Z",
    fill: "white"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8013 38.0391H16.8359V39.0044H17.8013V38.0391Z",
    fill: "white"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8013 37.0703H16.8359V38.0356H17.8013V37.0703Z",
    fill: "white"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8013 36.1094H16.8359V37.0747H17.8013V36.1094Z",
    fill: "white"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8013 35.1445H16.8359V36.1098H17.8013V35.1445Z",
    fill: "white"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8013 34.1797H16.8359V35.145H17.8013V34.1797Z",
    fill: "white"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8013 33.2109H16.8359V34.1763H17.8013V33.2109Z",
    fill: "white"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8013 16.793H16.8359V17.7583H17.8013V16.793Z",
    fill: "white"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8013 15.8281H16.8359V16.7934H17.8013V15.8281Z",
    fill: "white"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8013 14.8633H16.8359V15.8286H17.8013V14.8633Z",
    fill: "white"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8013 13.8984H16.8359V14.8638H17.8013V13.8984Z",
    fill: "white"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8013 12.9336H16.8359V13.8989H17.8013V12.9336Z",
    fill: "white"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8013 11.9648H16.8359V12.9302H17.8013V11.9648Z",
    fill: "white"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8013 11H16.8359V11.9653H17.8013V11Z",
    fill: "white"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8325 38.0391H15.8672V39.0044H16.8325V38.0391Z",
    fill: "white"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8325 37.0703H15.8672V38.0356H16.8325V37.0703Z",
    fill: "white"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8325 36.1094H15.8672V37.0747H16.8325V36.1094Z",
    fill: "white"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8325 35.1445H15.8672V36.1098H16.8325V35.1445Z",
    fill: "white"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8325 34.1797H15.8672V35.145H16.8325V34.1797Z",
    fill: "white"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8325 33.2109H15.8672V34.1763H16.8325V33.2109Z",
    fill: "white"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8325 32.2461H15.8672V33.2114H16.8325V32.2461Z",
    fill: "white"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8325 31.2773H15.8672V32.2427H16.8325V31.2773Z",
    fill: "white"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8325 30.3125H15.8672V31.2778H16.8325V30.3125Z",
    fill: "white"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8325 29.3438H15.8672V30.3091H16.8325V29.3438Z",
    fill: "white"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8325 28.3828H15.8672V29.3481H16.8325V28.3828Z",
    fill: "white"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8325 27.418H15.8672V28.3833H16.8325V27.418Z",
    fill: "white"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8325 26.4492H15.8672V27.4145H16.8325V26.4492Z",
    fill: "white"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8325 25.4883H15.8672V26.4536H16.8325V25.4883Z",
    fill: "white"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8325 24.5195H15.8672V25.4848H16.8325V24.5195Z",
    fill: "white"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8325 23.5547H15.8672V24.52H16.8325V23.5547Z",
    fill: "white"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8325 22.5859H15.8672V23.5513H16.8325V22.5859Z",
    fill: "white"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8325 21.6211H15.8672V22.5864H16.8325V21.6211Z",
    fill: "white"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8325 20.6523H15.8672V21.6177H16.8325V20.6523Z",
    fill: "white"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8325 19.6914H15.8672V20.6567H16.8325V19.6914Z",
    fill: "white"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8325 18.7266H15.8672V19.6919H16.8325V18.7266Z",
    fill: "white"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8325 17.7578H15.8672V18.7231H16.8325V17.7578Z",
    fill: "white"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8325 16.793H15.8672V17.7583H16.8325V16.793Z",
    fill: "white"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8325 15.8281H15.8672V16.7934H16.8325V15.8281Z",
    fill: "white"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8325 14.8633H15.8672V15.8286H16.8325V14.8633Z",
    fill: "white"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8325 13.8984H15.8672V14.8638H16.8325V13.8984Z",
    fill: "white"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8325 12.9336H15.8672V13.8989H16.8325V12.9336Z",
    fill: "white"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8325 11.9648H15.8672V12.9302H16.8325V11.9648Z",
    fill: "white"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8325 11H15.8672V11.9653H16.8325V11Z",
    fill: "white"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8638 37.0703H14.8984V38.0356H15.8638V37.0703Z",
    fill: "white"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8638 36.1094H14.8984V37.0747H15.8638V36.1094Z",
    fill: "white"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8638 35.1445H14.8984V36.1098H15.8638V35.1445Z",
    fill: "white"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8638 34.1797H14.8984V35.145H15.8638V34.1797Z",
    fill: "white"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8638 33.2109H14.8984V34.1763H15.8638V33.2109Z",
    fill: "white"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8638 32.2461H14.8984V33.2114H15.8638V32.2461Z",
    fill: "white"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8638 31.2773H14.8984V32.2427H15.8638V31.2773Z",
    fill: "white"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8638 30.3125H14.8984V31.2778H15.8638V30.3125Z",
    fill: "white"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8638 29.3438H14.8984V30.3091H15.8638V29.3438Z",
    fill: "white"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8638 28.3828H14.8984V29.3481H15.8638V28.3828Z",
    fill: "white"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8638 27.418H14.8984V28.3833H15.8638V27.418Z",
    fill: "white"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8638 26.4492H14.8984V27.4145H15.8638V26.4492Z",
    fill: "white"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8638 25.4883H14.8984V26.4536H15.8638V25.4883Z",
    fill: "white"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8638 24.5195H14.8984V25.4848H15.8638V24.5195Z",
    fill: "white"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8638 23.5547H14.8984V24.52H15.8638V23.5547Z",
    fill: "white"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8638 22.5859H14.8984V23.5513H15.8638V22.5859Z",
    fill: "white"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8638 21.6211H14.8984V22.5864H15.8638V21.6211Z",
    fill: "white"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8638 20.6523H14.8984V21.6177H15.8638V20.6523Z",
    fill: "white"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8638 19.6914H14.8984V20.6567H15.8638V19.6914Z",
    fill: "white"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8638 18.7266H14.8984V19.6919H15.8638V18.7266Z",
    fill: "white"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8638 17.7578H14.8984V18.7231H15.8638V17.7578Z",
    fill: "white"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8638 16.793H14.8984V17.7583H15.8638V16.793Z",
    fill: "white"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8638 15.8281H14.8984V16.7934H15.8638V15.8281Z",
    fill: "white"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8638 14.8633H14.8984V15.8286H15.8638V14.8633Z",
    fill: "white"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8638 13.8984H14.8984V14.8638H15.8638V13.8984Z",
    fill: "white"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8638 12.9336H14.8984V13.8989H15.8638V12.9336Z",
    fill: "white"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8638 11.9648H14.8984V12.9302H15.8638V11.9648Z",
    fill: "white"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M14.895 36.1094H13.9297V37.0747H14.895V36.1094Z",
    fill: "white"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M14.895 35.1445H13.9297V36.1098H14.895V35.1445Z",
    fill: "white"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M14.895 34.1797H13.9297V35.145H14.895V34.1797Z",
    fill: "white"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M14.895 33.2109H13.9297V34.1763H14.895V33.2109Z",
    fill: "white"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M14.895 32.2461H13.9297V33.2114H14.895V32.2461Z",
    fill: "white"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M14.895 31.2773H13.9297V32.2427H14.895V31.2773Z",
    fill: "white"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M14.895 30.3125H13.9297V31.2778H14.895V30.3125Z",
    fill: "white"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M14.895 29.3438H13.9297V30.3091H14.895V29.3438Z",
    fill: "white"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M14.895 28.3828H13.9297V29.3481H14.895V28.3828Z",
    fill: "white"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M14.895 27.418H13.9297V28.3833H14.895V27.418Z",
    fill: "white"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M14.895 26.4492H13.9297V27.4145H14.895V26.4492Z",
    fill: "white"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M14.895 25.4883H13.9297V26.4536H14.895V25.4883Z",
    fill: "white"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M14.895 24.5195H13.9297V25.4848H14.895V24.5195Z",
    fill: "white"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M14.895 23.5547H13.9297V24.52H14.895V23.5547Z",
    fill: "white"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M14.895 22.5859H13.9297V23.5513H14.895V22.5859Z",
    fill: "white"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M14.895 21.6211H13.9297V22.5864H14.895V21.6211Z",
    fill: "white"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M14.895 20.6523H13.9297V21.6177H14.895V20.6523Z",
    fill: "white"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M14.895 19.6914H13.9297V20.6567H14.895V19.6914Z",
    fill: "white"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M14.895 18.7266H13.9297V19.6919H14.895V18.7266Z",
    fill: "white"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M14.895 17.7578H13.9297V18.7231H14.895V17.7578Z",
    fill: "white"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M14.895 16.793H13.9297V17.7583H14.895V16.793Z",
    fill: "white"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M14.895 15.8281H13.9297V16.7934H14.895V15.8281Z",
    fill: "white"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M14.895 14.8633H13.9297V15.8286H14.895V14.8633Z",
    fill: "white"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M14.895 13.8984H13.9297V14.8638H14.895V13.8984Z",
    fill: "white"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M14.895 12.9336H13.9297V13.8989H14.895V12.9336Z",
    fill: "white"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9341 35.1445H12.9688V36.1098H13.9341V35.1445Z",
    fill: "white"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9341 34.1797H12.9688V35.145H13.9341V34.1797Z",
    fill: "white"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9341 33.2109H12.9688V34.1763H13.9341V33.2109Z",
    fill: "white"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9341 32.2461H12.9688V33.2114H13.9341V32.2461Z",
    fill: "white"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9341 31.2773H12.9688V32.2427H13.9341V31.2773Z",
    fill: "white"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9341 30.3125H12.9688V31.2778H13.9341V30.3125Z",
    fill: "white"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9341 29.3438H12.9688V30.3091H13.9341V29.3438Z",
    fill: "white"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9341 28.3828H12.9688V29.3481H13.9341V28.3828Z",
    fill: "white"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9341 27.418H12.9688V28.3833H13.9341V27.418Z",
    fill: "white"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9341 26.4492H12.9688V27.4145H13.9341V26.4492Z",
    fill: "white"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9341 25.4883H12.9688V26.4536H13.9341V25.4883Z",
    fill: "white"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9341 24.5195H12.9688V25.4848H13.9341V24.5195Z",
    fill: "white"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9341 23.5547H12.9688V24.52H13.9341V23.5547Z",
    fill: "white"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9341 22.5859H12.9688V23.5513H13.9341V22.5859Z",
    fill: "white"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9341 21.6211H12.9688V22.5864H13.9341V21.6211Z",
    fill: "white"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9341 20.6523H12.9688V21.6177H13.9341V20.6523Z",
    fill: "white"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9341 19.6914H12.9688V20.6567H13.9341V19.6914Z",
    fill: "white"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9341 18.7266H12.9688V19.6919H13.9341V18.7266Z",
    fill: "white"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9341 17.7578H12.9688V18.7231H13.9341V17.7578Z",
    fill: "white"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9341 16.793H12.9688V17.7583H13.9341V16.793Z",
    fill: "white"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9341 15.8281H12.9688V16.7934H13.9341V15.8281Z",
    fill: "white"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9341 14.8633H12.9688V15.8286H13.9341V14.8633Z",
    fill: "white"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9341 13.8984H12.9688V14.8638H13.9341V13.8984Z",
    fill: "white"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9653 34.1797H12V35.145H12.9653V34.1797Z",
    fill: "white"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9653 33.2109H12V34.1763H12.9653V33.2109Z",
    fill: "white"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9653 32.2461H12V33.2114H12.9653V32.2461Z",
    fill: "white"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9653 31.2773H12V32.2427H12.9653V31.2773Z",
    fill: "white"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9653 30.3125H12V31.2778H12.9653V30.3125Z",
    fill: "white"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9653 29.3438H12V30.3091H12.9653V29.3438Z",
    fill: "white"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9653 28.3828H12V29.3481H12.9653V28.3828Z",
    fill: "white"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9653 27.418H12V28.3833H12.9653V27.418Z",
    fill: "white"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9653 26.4492H12V27.4145H12.9653V26.4492Z",
    fill: "white"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9653 25.4883H12V26.4536H12.9653V25.4883Z",
    fill: "white"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9653 24.5195H12V25.4848H12.9653V24.5195Z",
    fill: "white"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9653 23.5547H12V24.52H12.9653V23.5547Z",
    fill: "white"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9653 22.5859H12V23.5513H12.9653V22.5859Z",
    fill: "white"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9653 21.6211H12V22.5864H12.9653V21.6211Z",
    fill: "white"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9653 20.6523H12V21.6177H12.9653V20.6523Z",
    fill: "white"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9653 19.6914H12V20.6567H12.9653V19.6914Z",
    fill: "white"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9653 18.7266H12V19.6919H12.9653V18.7266Z",
    fill: "white"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9653 17.7578H12V18.7231H12.9653V17.7578Z",
    fill: "white"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9653 16.793H12V17.7583H12.9653V16.793Z",
    fill: "white"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9653 15.8281H12V16.7934H12.9653V15.8281Z",
    fill: "white"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9653 14.8633H12V15.8286H12.9653V14.8633Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.c8fe0b85946265f0daa67c185c8597b0.svg";
export { ForwardRef as ReactComponent };